import React, { useEffect, useState } from 'react';
import { Instagram, Facebook, Youtube, Linkedin } from 'lucide-react';
import { getSocialConfig } from '../lib/social';

const TikTok = (p) => (
  <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.7 5.7 0 1 0 4.9 5.7V9a7.3 7.3 0 0 0 4.3 1.4V7.3a4.3 4.3 0 0 1-3.2-1.5z" /></svg>
);

export const SOCIALS = [
  { key: 'instagram', label: 'Instagram', Icon: Instagram },
  { key: 'facebook', label: 'Facebook', Icon: Facebook },
  { key: 'tiktok', label: 'TikTok', Icon: TikTok },
  { key: 'youtube', label: 'YouTube', Icon: Youtube },
  { key: 'linkedin', label: 'LinkedIn', Icon: Linkedin },
];

export default function SocialIcons() {
  const [links, setLinks] = useState({});
  useEffect(() => { getSocialConfig().then((c) => setLinks(c.links || {})); }, []);
  return (
    <div className="flex items-center gap-4" data-testid="footer-social-icons">
      {SOCIALS.filter((s) => links[s.key]).map(({ key, label, Icon }) => (
        <a key={key} href={links[key]} target="_blank" rel="noopener noreferrer" aria-label={label}
          data-testid={`footer-social-${key}`}
          className="text-white/50 hover:text-white hover:-translate-y-0.5 transition-[color,transform] duration-200">
          <Icon className="w-5 h-5" />
        </a>
      ))}
    </div>
  );
}
